/**
 * Bestätigte Logo-Vorschläge für Firmen, die es noch nicht gibt.
 *
 * Beim Inline-Anlegen einer Firma („aus dem Impressum übernehmen" am
 * Arbeitgeber, an Vereinen, an Beziehungen) entsteht die Firma erst beim
 * Speichern. Das Logo kann deshalb erst DANACH übernommen werden.
 *
 * Das Bild selbst wird hier im Speicher gehalten und nicht im Formularstand:
 * Der wird als JSON serialisiert und zwischengespeichert — eine data:-URL
 * von bis zu 1 MB hätte dort nichts verloren. Im Verweis (`ContactRef`) steht
 * nur der Schlüssel. Geht die Seite verloren, ist auch der Vorschlag weg;
 * das ist gewollt (dann wird einfach erneut gefragt).
 */
const merkliste = new Map<string, string>();
let zaehler = 0;

/** Einen bestätigten Vorschlag merken; liefert den Schlüssel für den Verweis. */
export function logoMerken(datenUrl: string): string {
  zaehler += 1;
  const schluessel = `logo-${Date.now().toString(36)}-${zaehler}`;
  merkliste.set(schluessel, datenUrl);
  return schluessel;
}

/** Den gemerkten Vorschlag zum Schlüssel — oder `null`. */
export function gemerktesLogo(schluessel: string | null | undefined): string | null {
  return schluessel ? (merkliste.get(schluessel) ?? null) : null;
}

/** Nach dem Übernehmen vergessen. */
export function logoVergessen(schluessel: string | null | undefined): void {
  if (schluessel) merkliste.delete(schluessel);
}

/**
 * Eine data:-URL als Datei — für die Anlage, die das Logo wie ein
 * hochgeladenes Foto erst beim Speichern über `upload/contact-photo` ablegt.
 */
export function datenUrlAlsDatei(datenUrl: string, name = "logo"): File {
  const treffer = /^data:([^;,]+);base64,(.*)$/s.exec(datenUrl);
  if (!treffer) throw new Error("Kein gültiges Bild.");
  const mime = treffer[1];
  const binaer = atob(treffer[2]);
  const bytes = new Uint8Array(binaer.length);
  for (let i = 0; i < binaer.length; i++) bytes[i] = binaer.charCodeAt(i);
  const endung = mime.split("/")[1]?.replace("jpeg", "jpg") ?? "png";
  return new File([bytes], `${name}.${endung}`, { type: mime });
}
